let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("eh78s"), load("kYgdm"), load("dclpt"), load("b886X"), load("emd3r"), load("hOsvD"), load("1gUNx")]).then(() => parcelRequire('6fTvc'));